import type {
  AddLearningTimeV2Data,
  SearchArticlesReq,
  SearchResult
} from '@/models/interface/reading';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class ReadingService extends ApiFactory {
  constructor() {
    super('Read');
  }

  getSearchArticles(params: SearchArticlesReq): Promise<ApiDataResponse<SearchResult>> {
    return this.post('SearchArticles', params);
  }

  addLearningTimeV2(params: AddLearningTimeV2Data): Promise<ApiDataResponse<boolean>> {
    return this.post('AddLearningTimeV2', params);
  }
}
